exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CrU9_{position:relative;margin-right:4px}._8v0OH{display:block;cursor:pointer;margin-bottom:5px;z-index:5}._1curi{bottom:2px;margin-right:0;margin-left:-3px}.ThE28{margin-left:3px}", ""]);

// exports
exports.locals = {
	"agencyLogo": "CrU9_",
	"editButton": "_8v0OH",
	"editLogo": "_1curi",
	"submitButton": "ThE28"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/PriceBlock/PriceButton/PriceButton.css
// module id = 1898
// module chunks = 1 17 18 19 37